import { z } from 'zod';

export const AdminListItemSchema = z.object({
  id: z.uuid(),
  email: z.email(),
  fullName: z.string().min(1),
  status: z.enum(['active', 'inactive']),
  createdAt: z.iso.datetime(),
  createdById: z.uuid().nullable(),
  createdByFullName: z.string().min(1).nullable(),
});

export type AdminListItem = z.infer<typeof AdminListItemSchema>;

export const ListAdminsResponseSchema = z.object({
  data: z.array(AdminListItemSchema),
});

export type ListAdminsResponse = z.infer<typeof ListAdminsResponseSchema>;

export const GetAdminPathParamsSchema = z.object({
  id: z.uuid(),
});

export const ActiveAdminKeySchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
});

export type ActiveAdminKey = z.infer<typeof ActiveAdminKeySchema>;

/**
 * The detail read deliberately stops being a bare alias of the list item: the
 * active-key list only serves the deactivation warning on the detail page, and
 * putting it on `AdminListItemSchema` would run a key lookup per row of the
 * admin list.
 *
 * `.default([])` because the typed client throws when a 2xx body fails this
 * schema: during a rolling deploy a new bundle can reach a pod that predates the
 * field, and an absent array must degrade to today's dialog rather than turn the
 * whole detail page into an error boundary.
 */
export const GetAdminResponseSchema = AdminListItemSchema.extend({
  activeAdminKeys: z.array(ActiveAdminKeySchema).default([]),
});

export type GetAdminResponse = z.infer<typeof GetAdminResponseSchema>;

export const CreateAdminBodySchema = z.object({
  email: z.email(),
  fullName: z.string().trim().min(1).max(120),
});

export type CreateAdminBody = z.infer<typeof CreateAdminBodySchema>;

export const CreateAdminResponseSchema = AdminListItemSchema;

export type CreateAdminResponse = z.infer<typeof CreateAdminResponseSchema>;

export const DeactivateAdminPathParamsSchema = z.object({
  id: z.uuid(),
});

export const DeactivateAdminResponseSchema = AdminListItemSchema;

export type DeactivateAdminResponse = z.infer<typeof DeactivateAdminResponseSchema>;
